import { TokenCell } from "../../../components/grid/cells/TokenCell";
import { Toolbar } from "../../../components/Toolbar";
import { formatCentsAsDollars } from "../../../util/formatters";
import { AdministrateBackgroundExportButton } from "../../components/AdministrateBackgroundExportButton";
import { AdministrateEnumFilter } from "../../components/AdministrateEnumFilter";
import { AdministrateTable } from "../../components/AdministrateTable";
import { PayorOptionsFilter } from "../../components/filters/PayorOptionsFilter";
import { SystemConfigLayout } from "../../components/SystemConfigLayout";
import { DESTROY, makeColumns, UPDATE, useAdministrateTable, useCreatePermission } from "../../utils";
import { CreateLabFeeScheduleByPlanTypeModal } from "../components/CreateLabFeeScheduleByPlanTypeModal";
import { ImportLabFeeScheduleByPlanTypeModal } from "../components/ImportLabFeeScheduleByPlanTypeModal";
import { LabFeeScheduleByPlanTypeActionCell } from "../components/LabFeeScheduleByPlanTypeActionCell";

const useColumns = makeColumns(() => [
  {
    id: "payor.name",
    accessor: "payor.name",
    Header: "Payor",
    disableSortBy: true,
    Filter: (props) => <PayorOptionsFilter {...props} valueKey="name" />,
  },
  {
    id: "cpt_code.code",
    accessor: "cptCode.code",
    Header: "CPT Code",
    Cell: TokenCell,
    Filter: (props) => <AdministrateEnumFilter {...props} resourceUrl="/admin/cpt_codes.json" valueKey="code" labelKey="code" />,
  },
  {
    id: "plan_type_group",
    accessor: "planTypeGroup",
    Header: "Plan Type",
    disableSortBy: true,
    Filter: (props) => (
      <AdministrateEnumFilter {...props} resourceUrl="/admin/enums/plan_type_groups.json" valueKey="id" labelKey="label" />
    ),
    Cell: TokenCell,
  },
  {
    id: "price_cents",
    accessor: "priceCents",
    Header: "Price",
    Cell: ({ value }) => <span>{formatCentsAsDollars(value)}</span>,
    disableFilters: true,
  },
  {
    id: "actions",
    Header: "Actions",
    Cell: LabFeeScheduleByPlanTypeActionCell,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const LabsFeeScheduleByPlanTypeTab = ({ labId, lab }) => {
  const extraParams = { lab: { id: labId } };
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable(extraParams);
  const [canCreate] = useCreatePermission("CptFeeScheduleByPlanType");

  const columns = useColumns();

  const onCreate = (newFeeSchedule) => {
    const { refresh, setMessage } = tableRef.current;

    setMessage(`Created Cpt Fee Schedule By Plan Type ${newFeeSchedule.id}`);
    refresh();
  };

  const onImport = (message, details = []) => {
    const { refresh, setMessage } = tableRef.current;

    setMessage(message, details.length ? "warning" : "success", details);
    refresh();
  };

  return (
    <SystemConfigLayout title="Cpt Fee Schedule By Plan Type">
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <AdministrateBackgroundExportButton
            outline
            className="me-2"
            exportUrl="/admin/cpt_fee_schedule_by_plan_types/export"
            filters={allFilters}
            ref={tableRef}
          />
          {canCreate && (
            <>
              <ImportLabFeeScheduleByPlanTypeModal labId={labId} outline className="me-2" onImport={onImport} />
              <CreateLabFeeScheduleByPlanTypeModal onCreate={onCreate} labId={labId} />
            </>
          )}
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={`/admin/cpt_fee_schedule_by_plan_types.json`}
        resourceName={"cpt_fee_schedule_by_plan_type"}
        extraParams={extraParams}
        permissions={[UPDATE, DESTROY]}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </SystemConfigLayout>
  );
};
